import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { API } from '@shared/types/api';
import { getReactionEmoji } from './types';
import styles from './ReactionList.module.css';

export interface ReactionListProps {
  reactions: API.ReactionFragment[];
}

export function ReactionList({ reactions }: ReactionListProps) {
  return (
    <View className={styles.reactionList}>
      {reactions.map((reaction, index) => (
        <View key={index} className={styles.reactionItem}>
          <View className={styles.image}>
            <MBUserImage
              size="small"
              user={reaction.user}
              style={{ width: '100%', height: '100%' }}
            />
          </View>
          <Text size="body1">{reaction.user.fullName}</Text>
          <Text className={styles.emoji}>{getReactionEmoji(reaction.type)}</Text>
        </View>
      ))}
    </View>
  );
}
